import { Box, Text } from "@simplybusiness/mobius";
import type { Upsell } from "../../types";
import { InfoModal } from "../InfoModal";
import type { DisplayVariant } from "../Coverage";
import { useSnowplowContext } from "@simplybusiness/services";

export type UpsellItemProps = {
  item: Upsell;
  displayVariant: DisplayVariant;
};

export const UpsellItem = ({ item, displayVariant }: UpsellItemProps) => {
  const { snowplow } = useSnowplowContext();

  const onTooltipOpen = (upsellName: string) => {
    snowplow?.trigger(`${displayVariant}UpsellTooltipHelperClicked`, {
      label: upsellName,
    });
  };

  return (
    <Box className="mobius-quote-card__upsell-item">
      <InfoModal
        toggleText={item.primaryText}
        title={item.primaryText}
        body={item.secondaryText}
        onOpen={() => onTooltipOpen(item.primaryText)}
      />

      <Text className="mobius-quote-card__upsell-price">
        {item.formattedPrice}
      </Text>
    </Box>
  );
};
